import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=1961f6c1&scoped=true"
import script from "./invoiceList.vue?vue&type=script&lang=js"
export * from "./invoiceList.vue?vue&type=script&lang=js"
import style0 from "./invoiceList.vue?vue&type=style&index=0&id=1961f6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961f6c1",
  null
  
)

export default component.exports